import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Grid, Row, Panel, Accordion } from 'react-bootstrap';
import { Button } from 'devextreme-react';
import { TextBox } from 'devextreme-react';
import "./userInfo.css";
import 'devextreme-react/text-area';

export default class UserInfo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userData: {
                lastName: '',
                firstName: '',
                patronymic: '',
                eMail: '',
                pHone: '',
                iNN: ''
            },
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            passwordVisible: false,
            newPasswordVisible: false,
            confirmPasswordVisible: false,
            changePasswordVisible: false,
            newPasswordDisabled: false
        };

        this.onPassChangeConfirm = this.onPassChangeConfirm.bind(this);
        this.onOldPasswordChanged = this.onOldPasswordChanged.bind(this);
        this.onNewPasswordChanged = this.onNewPasswordChanged.bind(this);
        this.onConfirmPasswordChanged = this.onConfirmPasswordChanged.bind(this);
        this.onChangePassClick = this.onChangePassClick.bind(this);
    }

    componentDidMount() {
        var tokenKey = "accessToken";

        var userData = {
            login: this.state.loginText,
            password: this.state.passwordText
        }

        var token = sessionStorage.getItem(tokenKey);

        fetch('api/main/UserInfo', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(userData)
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ userData: data });
            });
    }

    onChangePassClick(e) {
        this.setState({
            passwordVisible: true,
            newPasswordVisible: true,
            confirmPasswordVisible: true,
            changePasswordVisible: true,
            newPasswordDisabled: true
        });
    }

    onPassChangeConfirm(e) {
        var tokenKey = "accessToken";

        var passwordData = {
            oldPassword: this.state.oldPassword,
            newPassword: this.state.newPassword,
            confirmPassword: this.state.confirmPassword
        }

        var token = sessionStorage.getItem(tokenKey);

        fetch('api/main/ChangePassword', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(passwordData)
        })
            .then(response => response.json())
            .then(data => {

            });
    }

    onOldPasswordChanged(e) {
        this.setState({ oldPassword: e.value });
    }

    onNewPasswordChanged(e) {
        this.setState({ newPassword: e.value });
    }

    onConfirmPasswordChanged(e) {
        this.setState({ confirmPassword: e.value });
    }

    render() {

        return (
            <Grid fluid className="positionGrid">
                <Row>
                    <Col lg={9}>
                        <Panel header="Информация">
                            <Grid fluid className="positionInfo">
                                <Row>
                                    <Col lg={6}>
                                        <Grid fluid className="positionInfo">
                                            <Row>
                                                <Col lg={5}>
                                                    <div>Фамилия</div>
                                                </Col>
                                                <Col lg={7}>
                                                    <div>{this.state.userData.lastName}</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg={5}>
                                                    <div>Имя</div>
                                                </Col>
                                                <Col lg={7}>
                                                    <div>{this.state.userData.firstName}</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg={5}>
                                                    <div>Отчество</div>
                                                </Col>
                                                <Col lg={7}>
                                                    <div>{this.state.userData.patronymic}</div>
                                                </Col>
                                            </Row>
                                        </Grid>
                                    </Col>
                                    <Col lg={6}>
                                        <Grid fluid className="positionInfo">
                                            <Row>
                                                <Col lg={5}>
                                                    <div>Электронная почта</div>
                                                </Col>
                                                <Col lg={7}>
                                                    <div>{this.state.userData.eMail}</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg={5}>
                                                    <div>Телефон</div>
                                                </Col>
                                                <Col lg={7}>
                                                    <div>{this.state.userData.pHone}</div>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col lg={5}>
                                                    <div>ИНН</div>
                                                </Col>
                                                <Col lg={7}>
                                                    <div>{this.state.userData.iNN}</div>
                                                </Col>
                                            </Row>
                                        </Grid>
                                    </Col>
                                </Row>
                            </Grid>
                        </Panel>
                    </Col>
                    <Col lg={3}>
                        <Panel header="Безопасность">
                            <Grid fluid>
                                <Row>
                                    <Col lg={12}>
                                        <Button
                                            text={'Изменить пароль'}
                                            type={'danger'}
                                            width={200}
                                            onClick={this.onChangePassClick}
                                            disabled={this.state.newPasswordDisabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <TextBox value={this.state.passwordText} mode={'password'}
                                            onValueChanged={this.onOldPasswordChanged} visible={this.state.passwordVisible} className="topMargin10"
                                            placeholder={'Старый пароль'} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <TextBox value={this.state.passwordText} mode={'password'}
                                            onValueChanged={this.onNewPasswordChanged} visible={this.state.newPasswordVisible} className="topMargin10"
                                            placeholder={'Новый пароль'} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <TextBox value={this.state.passwordText} mode={'password'}
                                            onValueChanged={this.onConfirmPasswordChanged} visible={this.state.confirmPasswordVisible} className="topMargin10"
                                            placeholder={'Подтверждение'} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <Button className="topMargin10"
                                            text={'Подтвердить'}
                                            type={'danger'}
                                            width={200}
                                            visible={this.state.changePasswordVisible}
                                            onClick={this.onPassChangeConfirm}
                                        />
                                    </Col>
                                </Row>
                            </Grid>
                        </Panel>
                    </Col>
                </Row>
            </Grid>
        );
    }
}


// WEBPACK FOOTER //
// ./App/containers/userInfo/userInfo.jsx